import { GA_MEASUREMENT_ID } from "./seo";

type EventPayload = Record<string, string | number | boolean | undefined>;

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: unknown[];
  }
}

export { GA_MEASUREMENT_ID };

export function trackEvent(eventName: string, payload: EventPayload = {}) {
  if (typeof window === "undefined") {
    return;
  }

  // Custom events only. Do not send page_view here: gtag lives in index.html
  // and GA4 Enhanced Measurement already tracks history changes in this SPA.
  if (typeof window.gtag === "function") {
    window.gtag("event", eventName, payload);
    return;
  }

  console.info("[analytics]", eventName, payload);
}
